export default __webpack_public_path__ + "static/media/Boomstore.a23e2ea5.png";